import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCollections } from '../actions';

const MAX_ATTEMPTS = 5;

const useCollections = () => {
  const dispatch = useDispatch();
  const { collections } = useSelector((state) => state.clients);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!collections.loaded && !collections.loading && attempts < MAX_ATTEMPTS) {
      setTimeout(() => {
        dispatch(getCollections()).then(() => {
          setAttempts((prev) => prev + 1);
        });
      }, attempts > 0 ? attempts * 1000 : 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collections.loaded, collections.loading, attempts]);

  return {
    ...collections,
    loading: (collections.loading || (collections?.error && attempts < MAX_ATTEMPTS)) ? true : collections.loading,
    error: attempts === MAX_ATTEMPTS ? collections.error : null,
  };
};

export default useCollections;
